var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Form } from "@brushfire/ui";
import { useContext } from "react";
import Constants from "../../../data/constants";
import WidgetFieldset from "../../Helpers/WidgetFieldset";
import FormikContextListener from "../../Helpers/FormikContextListener";
import { postAttendeeDonate } from "../../../data/api";
import { useDispatch } from "react-redux";
import { handleErrors, handleSubmittedOrder } from "../../../data/helpers";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import { AppFormContext } from "../../../App";
var MyAttendeeDonate = function (_a) {
    var eventData = _a.eventData, attendee = _a.attendee, path = _a.path, refreshAttendeeList = _a.refreshAttendeeList, attendeeListUrl = _a.attendeeListUrl;
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var formikContext = useContext(AppFormContext).formikContext;
    var onSubmit = function (values, formikHelpers, setGlobalError) {
        postAttendeeDonate(attendee.id)
            .then(function (_a) {
            var data = _a.data;
            refreshAttendeeList();
            handleSubmittedOrder(data.result, eventData, history, true, attendeeListUrl);
        })
            .catch(function (err) {
            handleErrors(err, dispatch, formikContext, setGlobalError);
        })
            .finally(function () {
            formikHelpers.setSubmitting(false);
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(Form, __assign({ initialValues: {}, onSubmit: onSubmit, formikBagProps: {
                    submitButtonLabel: "Donate Back",
                }, useUnsavedPrompt: false }, { children: function (_a) {
                    var formikContext = _a.formikContext;
                    return (_jsx(_Fragment, { children: _jsx(WidgetFieldset, { children: _jsx("div", __assign({ className: "pos-relative" }, { children: _jsx(FormikContextListener, { currentPath: path, path: [Constants.Routes.myAttendeeDonate], formikContext: formikContext, active: true, initialValues: {}, focusDelay: 500 }) })) }) }));
                } })), _jsx("p", __assign({ className: "bold" }, { children: "Are you sure you want to donate this ticket back?" })), _jsx("p", { children: "Cancellation is not available online for this event, but you can donate them back. These tickets will immediately be returned and the ticketholders will not be able to attend this event." }), _jsx("p", { children: "You\u2019ll receive a confirmation receipt via email." }), _jsx("p", __assign({ className: "bold" }, { children: _jsx("i", { children: "This action cannot be undone." }) }))] }));
};
export default MyAttendeeDonate;
